import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    validationActions: {
        justifyContent: "center",
        [theme.breakpoints.up("md")]: {
            justifyContent: "flex-end",
        },
    },
    validationRetry: {
        textDecoration: "underline",
    },
}));
